
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScheduleConsultation = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/86d54ddcda63029da005b85ca6e54f68/b5a6c0d9bc70d8400f36872c2465ceb8.png" 
              alt="Hugh Muir Investment Corp Logo" 
              className="h-10 w-auto"
            />
            <h1 className="text-2xl font-bold text-blue-900" style={{ fontFamily: '"Pacifico", serif' }}>
              HUGH MUIR INVESTMENT CORP
            </h1>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
              Services
            </a>
            <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
              About
            </a>
            <a href="#expertise" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
              Expertise
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
              Testimonials
            </a>
            <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
              Contact
            </a>
            <Button 
              onClick={handleScheduleConsultation}
              className="bg-blue-600 text-white hover:bg-blue-700 focus:ring-4 focus:ring-blue-200"
            >
              Schedule Consultation
            </Button>
          </div>
          
          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-blue-600 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
        
        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4 pt-4">
              <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
                Services
              </a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
                About
              </a>
              <a href="#expertise" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
                Expertise
              </a>
              <a href="#testimonials" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
                Testimonials
              </a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
                Contact
              </a>
              <Button 
                onClick={handleScheduleConsultation}
                className="bg-blue-600 text-white hover:bg-blue-700 focus:ring-4 focus:ring-blue-200"
              >
                Schedule Consultation
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
